<template>
  <view class="canvas-container" :style="style">
    <canvas ref="canvas" class="scan-circle" :width="width" :height="height"></canvas>
  </view>
</template>
<script lang="ts" setup>
import { onMounted, ref } from "vue"

interface DataTextProps {
  style?: { [key: string]: string }
  rgb?: string
  angle?: number
  radius?: number
}

const props = withDefaults(defineProps<DataTextProps>(), {
  style: () => ({}),
  rgb: () => "255,255,255",
  angle: () => 360,
  radius: () => 75,
})

const canvas = ref<HTMLCanvasElement | null>(null)

const width = props.radius * 2
const height = props.radius * 2
const center = { x: width / 2, y: height / 2 }
let time = 0

const deg_to_pi = Math.PI / 180

function Point(r: number, deg: number) {
  return {
    x: r * Math.cos(deg_to_pi * deg),
    y: r * Math.sin(deg_to_pi * deg),
  }
}

function Color(op: number) {
  return "rgba(" + props.rgb + "," + op + ")"
}

onMounted(() => {
  const ctx = canvas.value?.getContext("2d")

  if (!ctx) return

  ctx.translate(center.x, center.y)
  const draw = () => {
    time += 1
    ctx.restore()
    // ctx.fillStyle = "#111"
    // ctx.beginPath()
    // ctx.rect(-2000, -2000, 4000, 4000)
    // ctx.fill()

    // ctx.strokeStyle = "rgba(255,255,255,0.1)"
    // ctx.moveTo(-width / 2, 0)
    // ctx.lineTo(width / 2, 0)
    // ctx.moveTo(0, -height / 2)
    // ctx.lineTo(0, height / 2)
    // ctx.stroke()

    ctx.strokeStyle = Color(1)
    const r = width / 2
    const line_deg = (time / 10) % 360
    // console.log(line_deg);

    const line_deg_len = props.angle
    let opacity = 1

    for (let i = 0; i < line_deg_len; i++) {
      // var deg = (time-i);
      const deg1 = line_deg - i - 10
      const deg2 = line_deg - i
      const pointx = Point(15, deg2)
      const point1 = Point(r, deg1)
      const point2 = Point(r, deg2)
      const point3 = Point(15, deg1)
      if (i > 0) opacity = 1 - i / line_deg_len - 0
      ctx.beginPath()
      // ctx.fillStyle="white";
      ctx.fillStyle = Color(opacity)
      ctx.moveTo(pointx.x, pointx.y)
      ctx.lineTo(point2.x, point2.y)
      ctx.lineTo(point1.x, point1.y)
      ctx.lineTo(point3.x, point3.y)
      // ctx.stroke();
      ctx.fill()
    }
  }

  draw()
  //   setInterval(draw, 5)
})
</script>
<style lang="scss" scoped>
.canvas-container {
  display: block;
  //   canvas {
  //     width: 300px;
  //     height: 300px;
  //   }
  //   旋转动画
  .scan-circle {
    animation: rotate 5s linear infinite;
    opacity: 0.5;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
